module.exports = __webpack_public_path__ + "img/collection-diamondJewelryWhitegold@2x.d9ea894.webp";